import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/components/icon/icon.module';
import { AppTableModule } from 'src/app/components/table';
import { TooltipModule } from 'src/app/components/tooltip/tooltip.module';

import { NgxShimmerLoadingModule } from 'src/app/components/ngx-shimmer-loading/ngx-shimmer-loading.module';

import { TableRefreshModule } from '../table-refresh/table-refresh.module';
import { PaginatorModule } from '../paginator/paginator.module';

import { DynamicTableComponent } from './dynamic-table.component';

@NgModule({
  imports: [
    CdkDrag,
    CdkDropList,
    CommonModule,
    IconModule,
    AppTableModule,
    TooltipModule,

    NgxShimmerLoadingModule,

    TableRefreshModule,
    PaginatorModule,
  ],
  declarations: [DynamicTableComponent],
  exports: [DynamicTableComponent],
})
export class DynamicTableModule {}
